export enum EReferralCodesRewardReceivers {
  Inviter = 'inviter',
  // Invitee = 'invitee',
}
